<!--
 * @CopyRight: 广州仰望星空云科技有限公司
 * @Author: linkaiyan
 * @Email: linkaiyan@xinyu668.com
 * @Date: 2023-09-25 17:23:59
 * @LastEditTime: 2023-09-25 17:52:02
 * @LastEditors: linkaiyan
 * @Description:
-->
<template>
  <component :is="tagName" :class="['animation-button', { active: isActive }]" @click="showAni">
    <slot></slot>
  </component>
</template>

<script setup lang='ts'>
import { ref } from 'vue';

const props = defineProps({
  tagName: {
    type: String,
    default: 'button'
  }
});

const emits = defineEmits(['click'])

const isActive = ref(false);

const showAni = ($event) => {
  emits('click', $event);
  isActive.value = true;
  setTimeout(() => {
    isActive.value = false;
  }, 600);
}

</script>

<style lang='scss' scoped>
@use '../styles/_animate.scss';

.animation-button {
  &.active {
    animation: heartBeat .6s;
  }
}
</style>
